import { render, staticRenderFns } from "./ContractBalances.vue?vue&type=template&id=1c83de34&"
import script from "./ContractBalances.vue?vue&type=script&lang=js&"
export * from "./ContractBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports